<template>
    <div id='layout'>
        <nav class="navbar navbar-color-on-scroll navbar-transparent fixed-top navbar-expand-lg" color-on-scroll="100">
            <div class="container">
                <div class="navbar-translate">
                    <!-- <a class="navbar-brand" href="#"><img id='logoImg' src='/static/img/logo2.png' /></a> -->
                    <router-link class="navbar-brand" :to="'/'"><img id='logoImg' src='/static/img/logo2.png' /></router-link>
                    <button class="navbar-toggler" type="button" data-toggle="collapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="navbar-toggler-icon"></span>
                        <span class="navbar-toggler-icon"></span>
                        <span class="navbar-toggler-icon"></span>
                    </button>
                </div>
                <div class="collapse navbar-collapse">
                    <ul class="navbar-nav ml-auto">
                        <template v-for='(item,index) in menu'>
                            <li class="dropdown nav-item" v-if='item.subItems' :key='index' @mouseover = "item.mouseTxt = item.txtEName" @mouseleave="item.mouseTxt = item.txtCName">
                                <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown" aria-expanded="false">
                                    <i class="material-icons">{{item.icon}}</i>
                                    <!-- <span>{{item.mouseTxt}}</span> -->
                                    <span>{{ $t(''+ item.trName +'') }}</span>
                                    <div class="ripple-container"></div>
                                </a>
                                <div class="dropdown-menu dropdown-with-icons">
                                    <div v-for='(subItem,subIndex) in item.subItems' :key='`subMenu${subIndex}`' @mouseover = "subItem.mouseTxt = subItem.txtEName" @mouseleave="subItem.mouseTxt = subItem.txtCName">
                                        <template v-if='item.routName'>
                                            <router-link class="dropdown-item" :to="'/'+item.routName+'/'+subItem.routName">
                                            <!-- <span>{{subItem.mouseTxt}}</span> -->
                                            <span>{{ $t(''+ subItem.trName +'') }}</span>
                                        </router-link>
                                        </template>
                                        <!-- 語言轉換 用 -->
                                        <template v-else>
                                            <span class="dropdown-item" @click="selectLanguage(subItem.selName)" style="cursor: pointer;">{{ $t(''+ subItem.trName +'') }}</span>
                                        </template>

                                    </div>

                                </div>
                            </li>
                            <li class='nav-item' v-else :key='`oneMenu${index}`'  @mouseover = "item.mouseTxt = item.txtEName" @mouseleave="item.mouseTxt = item.txtCName">
                                <router-link class="nav-link" :to="'/'+item.routName" >
                                    <i class="material-icons">{{item.icon}}</i>
                                    <!-- <span>{{item.mouseTxt}}</span> -->
                                    <span>{{ $t(''+ item.trName +'') }}</span>
                                </router-link>
                            </li>
                        </template>
                    </ul>
                </div>

            </div>
        </nav>
        <router-view :catalog="catalog"></router-view>
        <footer class="footer footer-default">
            <div class="container">
                <nav class="float-left">
                <ul>
                    <li>
                        <!-- <a href="https://www.creative-tim.com/">
                            SMC
                        </a> -->
                    </li>
                </ul>
                </nav>
                <div class="copyright float-right">
                    <!-- &copy;
                    made with <i class="material-icons">favorite</i> by
                    <a href="https://www.creative-tim.com/" target="blank">Creative Tim</a> for a better web. -->
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'layout',
    data() {
        return {
            navActive: 'index',
            menu: [
                {txtCName: '最新消息', trName: 'NAV_MENU.NEWS', txtEName: 'NEWS', mouseTxt:'最新消息', routName: 'news', icon: 'home'},
                {txtCName: '解決方案', trName: 'NAV_MENU.SOLUTION', txtEName: 'SOLUTION', mouseTxt:'解決方案', routName: 'youtube', icon: 'build'},
                {txtCName: '活動花絮', trName: 'NAV_MENU.ACTIVITY', txtEName: 'ACTIVITY', mouseTxt:'活動花絮', routName: 'visit', icon: 'supervisor_account'},
                {txtCName: '關於中心', trName: 'NAV_MENU.ABOUT_SMC', txtEName: 'ABOUT SMC', mouseTxt:'關於中心', routName: 'about', icon: 'insert_comment', subItems: [
                    {txtCName: '中心沿革', trName: 'NAV_SUB_MENU.History', txtEName: 'History', mouseTxt:'中心沿革', routName: 'history', icon: 'keyboard_arrow_right'},
                    {txtCName: '中心成員', trName: 'NAV_SUB_MENU.Members', txtEName: 'Members', mouseTxt:'中心成員', routName: 'member', icon: 'keyboard_arrow_right'},
                    {txtCName: '產學成果', trName: 'NAV_SUB_MENU.Achievements', txtEName: 'Achievements', mouseTxt:'產學成果', routName: 'achievement', icon: 'keyboard_arrow_right'},
                    {txtCName: '空間介紹一樓', trName: 'NAV_SUB_MENU._1F', txtEName: 'Space tour 1F', mouseTxt:'空間介紹一樓', routName: 'plan_1F', icon: 'keyboard_arrow_right'},
                    {txtCName: '空間介紹二樓', trName: 'NAV_SUB_MENU._2F', txtEName: 'Space tour 2F', mouseTxt:'空間介紹二樓', routName: 'plan_2F', icon: 'keyboard_arrow_right'}
                ]},
                {txtCName: '輔導案例', trName: 'NAV_MENU.SAMPLE_CASE', txtEName: 'SAMPLE CASE', mouseTxt:'輔導案例', routName: 'case', icon: 'group', subItems: [
                    {txtCName: '泰國 BDI Group', trName: 'NAV_SUB_MENU.Case_BDI', txtEName: 'BDI Group', mouseTxt:'泰國 BDI Group', routName: 'BDI_Group', icon: 'keyboard_arrow_right'},
                ]},
                {txtCName: '聯絡我們', trName: 'NAV_MENU.CONTACT', txtEName: 'CONTACT', mouseTxt:'聯絡我們', routName: 'contact', icon: 'email', subItems: [
                    {txtCName: '聯絡我們', trName: 'NAV_SUB_MENU._Contact', txtEName: 'Contact us', mouseTxt:'聯絡我們', routName: '', icon: 'keyboard_arrow_right'},
                    {txtCName: '交通位置', trName: 'NAV_SUB_MENU.Location', txtEName: 'Location', mouseTxt:'交通位置', routName: 'position', icon: 'keyboard_arrow_right'}
                ]},
                {trName: 'language.select', icon:'sync', subItems:[
                    {trName: 'language.tw', selName: 'tw'},
                    {trName: 'language.en', selName: 'en'}
                ]}
            ]
        }
    },
    computed:{
        catalog() {
            // console.log(this.$route.path);
            const [root, catalog,subCatalog] = this.$route.path.split('/')
            return catalog ? catalog : 'index'
        },
        subCatalog(){
            const [root, catalog, subCatalog] = this.$route.path.split('/')
            return subCatalog ? subCatalog : ''
        },
        checkParams() {
            return (this.$route.params.projectId) ? this.$route.params.projectId : ''
        },
    },
    methods: {
        toggleSideBar() {
            $("#navbar-toggler").click(function (e) {
                console.log('navbar-toggler')
                // e.preventDefault();
                // $("#wrapper").toggleClass("active");
            });
        },
        selectLanguage(language) {
            this.$i18n.locale = language;
            localStorage.setItem("locale", language);
        }
    },
    mounted() {
        this.toggleSideBar();
        this.$i18n.locale = "tw"
    },
    created() {
        this.navActive = (this.$route.path.split('/')[1]) ? `${this.$route.path.split('/')[1]}` : 'index';
    },
    watch:{
        '$route' (to, from) {
            this.navActive = (to.path.split('/')[1]) ? `${to.path.split('/')[1]}` : 'index';

        }
    },
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/layout.vue